import { Box, Button, Grid, Typography } from "@mui/material";
import taylorUgc from "assets/home/taylor.png";

import { trackEvent } from "utils/tracking";

const TaylorVaultCard = () => {
  return (
    <Box
      sx={{
        p: 3,
        background:
          "linear-gradient(57.59deg, #151F16 -1.58%, #004537 98.35%), linear-gradient(180deg, rgba(236, 234, 229, 0) 0%, #ECEAE5 100%), #FFFFFF",
        borderRadius: 4,
      }}
    >
      <Grid
        container
        gap={2}
        justifyContent={"space-between"}
        alignItems={"center"}
      >
        <Grid item xs>
          <Box
            sx={{
              backgroundColor: "white",
              borderRadius: 8,
              mb: 1,
              py: 1,
              px: 2,
              width: "max-content",
              fontSize: 13,
              fontWeight: 600,
              color: "#333",
            }}
          >
            🔐 Creator Resources
          </Box>
          <Typography
            variant="h4"
            sx={{ color: "yellow.main", fontWeight: 700, mb: 1 }}
          >
            Grab Taylor's Creator Partnership Vault
          </Typography>
          <Typography sx={{ color: "white", mb: 2, fontSize: 14 }}>
            Access 1,300+ resources to help you land brand deals including brand
            contacts, pitch templates, negotiation scripts, canva templates, &
            more.
          </Typography>
        </Grid>

        <Grid item xs="auto">
          <Box
            component="img"
            sx={{
              width: { xs: 80, md: 120 },
              borderRadius: "50%",
              mb: 2,
              border: "1px solid white",
            }}
            src={taylorUgc}
          />
        </Grid>
      </Grid>

      <Button
        variant="outlined"
        fullWidth
        href="https://shop.taylorsocials.com/creator-partnership-vault/?ref=bento"
        target="_blank"
        rel="noopener noreferrer"
        onClick={() =>
          trackEvent("Partner Offers View Offer Clicked", {
            Offer: "Taylor Creator Partnership Vault",
          })
        }
        sx={{
          borderRadius: 2,
          py: 1,
          color: "white",
          borderColor: "white",
          "&:hover": {
            borderColor: "white",
            backgroundColor: "rgba(255,255,255,0.15)",
          },
        }}
      >
        GET INSTANT ACCESS
      </Button>
    </Box>
  );
};

export default TaylorVaultCard;
